/*
 * Module for support FAQ view
*/
rs.module("ui/content/support/faq",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, cssClasses) {

            // Unpack Js Selectors
            var faqs = $.js(jsSelectors.faqs);
            var categoryContents = faqs.js(jsSelectors.categoryContents, { multiple: true, required: false });
            var answers = faqs.js(jsSelectors.answers, { multiple: true, required: false });
            var faqCategoryHeader = faqs.js(jsSelectors.faqCategoryHeader, { multiple: true, required: false });
            
            // Trigger events as a collapsible element is expanded or collapsed
            categoryContents.on('show.bs.collapse', toggleCollapseHeader);
            categoryContents.on('hide.bs.collapse', toggleCollapseHeader);
            answers.on('show.bs.collapse', toggleCollapseHeader);
            answers.on('hide.bs.collapse', toggleCollapseHeader);

            // Handle the icon position and background color when toggling collapsible elements
            function toggleCollapseHeader(event) {
                // Stop this event from affecting other collapsible elements
                event.stopPropagation();

                var collapsibleId = faqs.find(this).attr("id");
                var icon = faqs.find(`[icon-for=${collapsibleId}]`)

                // If this is for a category, also toggle ._selected
                if (collapsibleId.includes("category")) {
                    icon.closest(faqCategoryHeader, faqs).toggleClass(cssClasses.selected)
                }

                icon.toggleClass(cssClasses.expanded);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);